import moment from "moment";
import { useState } from "react";
import { SingleDatePicker, isInclusivelyBeforeDay } from "react-dates";

import { weekDayMap } from '../../utils/weekConfig';

const CustomInputIcon = ({ customClassName }) => {
  const size = customClassName ? "14" : "20";
  const marginTop = customClassName ? "-8px" : "-2px";
  
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginTop }}>
      <path d="M6.66675 1.66667V4.16667" stroke="#353A46" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M13.3333 1.66667V4.16667" stroke="#353A46" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M2.91675 7.5H17.0834" stroke="#353A46" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M17.5 6.66667V14.1667C17.5 16.8334 16.1667 18.3334 13.1667 18.3334H6.83337C3.83337 18.3334 2.5 16.8334 2.5 14.1667V6.66667C2.5 4 3.83337 2.5 6.83337 2.5H13.1667C16.1667 2.5 17.5 4 17.5 6.66667Z" stroke="#353A46" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M13.75 11.25H13.7575" stroke="#353A46" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M10.0025 11.25H10.01" stroke="#353A46" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M6.25 11.25H6.2575" stroke="#353A46" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M13.75 14.5H13.7575" stroke="#353A46" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M10.0025 14.5H10.01" stroke="#353A46" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M6.25 14.5H6.2575" stroke="#353A46" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
};

const DatePicker = ({
  width="auto",
  date,
  onDateChange,
  placeholder,
  allowPreviousDates,
  disableFutureDates,
  disableCurrentAndFutureDates,
  disablePreviousDatesFrom,
  disabled,
  error,
  dateDisplayFormat = localStorage.getItem('date_format') || 'DD/MM/YYYY',
  startDayOfWeek = localStorage.getItem('start_day_of_week' || 'monday'),
  customClassName = null,
}) => {
  const [focused, setFocused] = useState(false);

  return (
    <div
      className={error ? `error ${customClassName || ''}` : customClassName}
      onClick={() => {
        setFocused(true);
      }}
      style={{width}}
    >
      <SingleDatePicker
        numberOfMonths={1}
        onDateChange={date => onDateChange(date)}
        onFocusChange={({ focused }) => setFocused(focused)}
        focused={focused}
        date={date}
        firstDayOfWeek={weekDayMap[startDayOfWeek]}
        weekDayFormat="dd"
        displayFormat={dateDisplayFormat}
        showDefaultInputIcon={false}
        customInputIcon={<CustomInputIcon customClassName={customClassName} />}
        inputIconPosition="after"
        hideKeyboardShortcutsPanel
        placeholder={placeholder}
        disabled={disabled ? true : false}
        readOnly
        isOutsideRange={
          disableFutureDates
            ? day => !isInclusivelyBeforeDay(day, moment())
            : allowPreviousDates
            ? () => false
            : disableCurrentAndFutureDates
            ? day => !isInclusivelyBeforeDay(day, moment().subtract(1, 'day'))
            : disablePreviousDatesFrom
            ? day => day.isBefore(moment(disablePreviousDatesFrom))
            : day => {
                if (day.isSameOrBefore(moment().subtract(1, 'day'))) {
                  return true;
                }
                return false;
              }
        }
      />
    </div>
  );
};

export default DatePicker;
